import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Add axios interceptor to include authentication token
axios.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// AUTH MODULE
export const login = async (credentials) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, credentials);
    return response.data;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};


//USER MODULE
export const listAvailableRooms = async ({ room_type_id, check_in_date }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/rooms/available`,
            {
                params: {
                    room_type_id,
                    check_in_date
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error listing available rooms:', error);
        throw error;
    }
};

export const searchRooms = async (searchParams) => {
    try {

        console.log("🔍 Searching rooms!");
        
        const response = await axios.post(`${API_BASE_URL}/rooms/search`, searchParams);

        return response.data;
    } catch (error) {
        console.error('Error searching rooms:', error);
        throw error;
    }
};

export const reserveRoom = async (reservationDetails) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/reservations/reserve`, reservationDetails);
        return response.data;
    } catch (error) {
        console.error('Error reserving room:', error);
        throw error;
    }
};


//MANAGER MODULE
export const getUnservedReservations = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/reservations/list-unserved`);
        return response.data;
    } catch (error) {
        console.error('Error fetching unserved reservations:', error);
        throw error;
    }
};

export const getCheckedInReservations = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/reservations/list-checkedin`);
        return response.data;
    } catch (error) {
        console.error('Error fetching checked-in reservations:', error);
        throw error;
    }
};

export const getReservationHistory = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/reservations/list-history`);        
        return response.data;
    } catch (error) {
        console.error('Error fetching reservation history:', error);
        throw error;
    }
};

export const updateReservationStatus = async ({ id, status, room_id = null, personnel_notes = '' }) => {
    try {
        const response = await axios.patch(
            `${API_BASE_URL}/reservations/update-status/${id}`,
            {
                status,
                room_id,
                personnel_notes
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error updating reservation status:', error);
        throw error;
    }
};

export const checkOut = async (id) => {
    try {
        const response = await axios.patch(`${API_BASE_URL}/reservations/checkout/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error checking out reservation:', error);
        throw error;
    }
};

export const addReservationCharge = async ({ reservation_id, description, amount, status }) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/reservations/charges/${reservation_id}`,
            {
                charges: [{
                    description,
                    amount,
                    status
                }]
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error adding reservation charge:', error);
        throw error;
    }
};

export const updateReservationChargeStatus = async ({ charge_id, status }) => {
    try {
        const response = await axios.patch(
            `${API_BASE_URL}/reservations/update-charge/${charge_id}`,
            { status }
        );
        return response.data;
    } catch (error) {
        console.error('Error updating reservation charge status:', error);
        throw error;
    }
};

export const getReservationById = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/reservations/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching reservation by ID:', error);
        throw error;
    }
};

export const getCalendarReservations = async (startDate, endDate) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/reservations/calendar`, {
            params: {
                start_date: startDate,
                end_date: endDate
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching calendar reservations:', error);
        throw error;
    }
};

//ADMIN MODULE - ROOM MANAGEMENT
export const createRoom = async (roomData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/rooms`, roomData);
        return response.data;
    } catch (error) {
        console.error('Error creating room:', error);
        throw error;
    }
};

export const updateRoom = async (id, roomData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/rooms/${id}`, roomData);
        return response.data;
    } catch (error) {
        console.error('Error updating room:', error);
        throw error;
    }
};

export const deleteRoom = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/rooms/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting room:', error);
        throw error;
    }
};

export const getAllRooms = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/rooms/list-rooms-all`);
        return response.data;
    } catch (error) {
        console.error('Error fetching all rooms:', error);
        throw error;
    }
};

//ADMIN MODULE - ROOM TYPE MANAGEMENT
export const createRoomType = async (roomTypeData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/room-types`, roomTypeData);
        return response.data;
    } catch (error) {
        console.error('Error creating room type:', error);
        throw error;
    }
};

export const updateRoomType = async (id, roomTypeData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/room-types/${id}`, roomTypeData);
        return response.data;
    } catch (error) {
        console.error('Error updating room type:', error);
        throw error;
    }
};

export const deleteRoomType = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/room-types/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting room type:', error);
        throw error;
    }
};

export const getAllRoomTypes = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/room-types`);
        return response.data;
    } catch (error) {
        console.error('Error fetching all room types:', error);
        throw error;
    }
};

export const getMaxCapacity = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/room-types/max-capacity`);
        return response.data;
    } catch (error) {
        console.error('Error fetching max capacity:', error);
        throw error;
    }
};

//ADMIN MODULE - ROOM PHOTO MANAGEMENT
export const createRoomPhoto = async (formData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/room-photos`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error creating room photo:', error);
        throw error;
    }
};

export const updateRoomPhoto = async (id, photoData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/room-photos/${id}`, photoData);
        return response.data;
    } catch (error) {
        console.error('Error updating room photo:', error);
        throw error;
    }
};

export const deleteRoomPhoto = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/room-photos/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting room photo:', error);
        throw error;
    }
};

export const getRoomPhotos = async (roomTypeId) => {
    try {
        console.log(`Fetching room photos for room type ID: ${roomTypeId}`);

        const response = await axios.get(`${API_BASE_URL}/room-photos?room_type_id=${roomTypeId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching room photos:', error);
        throw error;
    }
};

export const getAllRoomPhotos = async () => {
    try {
        console.log('Fetching all room photos');

        const response = await axios.get(`${API_BASE_URL}/room-photos`);
        return response.data;
    } catch (error) {
        console.error('Error fetching all room photos:', error);
        throw error;
    }
};

//USER MANAGEMENT MODULE
export const getAllUsers = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/auth/list-users-`);
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const createUser = async (userData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/auth/register`, userData);
        return response.data;
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
};

export const updateUser = async (userId, userData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/auth/users/${userId}`, userData);
        return response.data;
    } catch (error) {
        console.error('Error updating user:', error);
        throw error;
    }
};

export const deleteUser = async (userId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/auth/users/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting user:', error);
        throw error;
    }
};

// VOUCHER MODULE
export const getVouchers = async (params = {}) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/vouchers`, { params });
        
        // Check what we receive from API for voucher 7L7H9XSN
        const targetVoucher = response.data.vouchers?.find(v => v.code === '7L7H9XSN');
        if (targetVoucher) {
            console.log('\n🌐 API CLIENT - Raw response from server for 7L7H9XSN:');
            console.log('  booking_start_date:', targetVoucher.booking_start_date, 'type:', typeof targetVoucher.booking_start_date);
            console.log('  booking_end_date:', targetVoucher.booking_end_date, 'type:', typeof targetVoucher.booking_end_date);
        }
        
        return response.data;
    } catch (error) {
        console.error('Error fetching vouchers:', error);
        throw error;
    }
};

export const getVoucherById = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/vouchers/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching voucher:', error);
        throw error;
    }
};

export const createVoucher = async (voucherData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/vouchers`, voucherData);
        return response.data;
    } catch (error) {
        console.error('Error creating voucher:', error);
        throw error;
    }
};

export const updateVoucher = async (id, voucherData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/vouchers/${id}`, voucherData);
        return response.data;
    } catch (error) {
        console.error('Error updating voucher:', error);
        throw error;
    }
};

export const deleteVoucher = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/vouchers/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting voucher:', error);
        throw error;
    }
};

export const validateVoucher = async (code, room_type_id = null, check_in_date = null) => {
    try {
        const payload = { code };
        if (room_type_id) {
            payload.room_type_id = room_type_id;
        }
        if (check_in_date) {
            payload.check_in_date = check_in_date;
        }
        const response = await axios.post(`${API_BASE_URL}/vouchers/validate`, payload);
        return response.data;
    } catch (error) {
        console.error('Error validating voucher:', error);
        throw error;
    }
};

export const applyVoucher = async (reservationId, voucherCode, discountAmount) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/vouchers/apply`, {
            reservation_id: reservationId,
            voucher_code: voucherCode,
            discount_amount: discountAmount
        });
        return response.data;
    } catch (error) {
        console.error('Error applying voucher:', error);
        throw error;
    }
};

// RESERVATION DISCOUNTS API (Multi-discount support)
export const addReservationDiscount = async (discountData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/reservation-discounts`, discountData);
        return response.data;
    } catch (error) {
        console.error('Error adding reservation discount:', error);
        throw error;
    }
};

export const getReservationDiscounts = async (reservationId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/reservation-discounts/reservation/${reservationId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching reservation discounts:', error);
        throw error;
    }
};

export const removeReservationDiscount = async (discountId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/reservation-discounts/${discountId}`);
        return response.data;
    } catch (error) {
        console.error('Error removing reservation discount:', error);
        throw error;
    }
};

export const getReservationDiscountSummary = async (reservationId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/reservation-discounts/reservation/${reservationId}/summary`);
        return response.data;
    } catch (error) {
        console.error('Error fetching reservation discount summary:', error);
        throw error;
    }
};

export const validateMultipleDiscounts = async (reservationId, discountType) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/reservation-discounts/validate`, {
            reservation_id: reservationId,
            discount_type: discountType
        });
        return response.data;
    } catch (error) {
        console.error('Error validating multiple discounts:', error);
        throw error;
    }
};

// BLOCKED DATES MODULE
export const getBlockedDates = async (startDate, endDate) => {
    try {
        const params = {};
        if (startDate) params.start_date = startDate;
        if (endDate) params.end_date = endDate;
        
        const response = await axios.get(`${API_BASE_URL}/blocked-dates`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching blocked dates:', error);
        throw error;
    }
};

export const createBlockedDate = async (blockedDateData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/blocked-dates`, blockedDateData);
        return response.data;
    } catch (error) {
        console.error('Error creating blocked date:', error);
        throw error;
    }
};

export const updateBlockedDate = async (id, blockedDateData) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/blocked-dates/${id}`, blockedDateData);
        return response.data;
    } catch (error) {
        console.error('Error updating blocked date:', error);
        throw error;
    }
};

export const deleteBlockedDate = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/blocked-dates/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting blocked date:', error);
        throw error;
    }
};

// ============================================================
// CUSTOMER FLAGS MODULE
// ============================================================

/**
 * Create a new customer flag
 * @param {Object} flagData - { reservation_id, reason, flagged_by }
 */
export const createCustomerFlag = async (flagData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/flags`, flagData);
        return response.data;
    } catch (error) {
        console.error('Error creating customer flag:', error);
        throw error;
    }
};

/**
 * Get all customer flags
 * @param {boolean} includeInactive - Whether to include inactive flags
 */
export const getAllCustomerFlags = async (includeInactive = false) => {
    try {
        const params = includeInactive ? { include_inactive: 'true' } : {};
        const response = await axios.get(`${API_BASE_URL}/flags`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching customer flags:', error);
        throw error;
    }
};

/**
 * Get a single customer flag by ID
 * @param {number} id - Flag ID
 */
export const getCustomerFlagById = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/flags/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching customer flag:', error);
        throw error;
    }
};

/**
 * Check if customer data matches any active flags
 * @param {Object} customerData - { guest_name, guest_email, guest_contact, ip_address }
 */
export const checkCustomerFlag = async (customerData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/flags/check`, customerData);
        return response.data;
    } catch (error) {
        console.error('Error checking customer flag:', error);
        throw error;
    }
};

/**
 * Unflag a customer (set is_active to false)
 * @param {number} id - Flag ID
 * @param {string} unflaggedBy - Username of person unflagging
 */
export const unflagCustomer = async (id, unflaggedBy = null) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/flags/${id}/unflag`, {
            unflagged_by: unflaggedBy
        });
        return response.data;
    } catch (error) {
        console.error('Error unflagging customer:', error);
        throw error;
    }
};

/**
 * Update flag reason
 * @param {number} id - Flag ID
 * @param {string} reason - New reason
 */
export const updateCustomerFlag = async (id, reason) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/flags/${id}`, { reason });
        return response.data;
    } catch (error) {
        console.error('Error updating customer flag:', error);
        throw error;
    }
};

/**
 * Delete a flag permanently
 * @param {number} id - Flag ID
 */
export const deleteCustomerFlag = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/flags/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting customer flag:', error);
        throw error;
    }
};



